import React from "react";
import Label from "../../Common/Label"; // adjust import based on your structure

const Loading: React.FC = () => {
  return (
    <div className="container" id="campaign-container">
      <div
        className="col d-flex align-items-center justify-content-center"
        style={{ minHeight: "400px" }}
      >
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          {/* <div className="mt-3">
            <Label
              children="Loading form data..."
              fontWeight={500}
              fontSize="14px"
              color="#4E4E4E"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Loading;
